import { EffectCallback, useEffect, useRef } from 'react';

/** Prefer using useEffect but if you must, use this */
export function useSetup(setup: EffectCallback) {
  const alreadyRan = useRef(false);

  useEffect(() => {
    if (alreadyRan.current) return;
    alreadyRan.current = true;

    return setup();
  }, []);
}
